import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomTokenDTO } from '../interfaces/customToken.interface';
import { ApiEndpoints } from '../common/apiPoint';
import {
  Configurations,
  GoogleConfigurations,
} from '../interfaces/configurations.interface';
import { AppTools } from '../interfaces/appTools.interface';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(readonly http: HttpClient) {}

  GetGoogleAPIConfigurations(): Observable<GoogleConfigurations> {
    const key = 'GoogleAPIkeyDispatcher';
    const isLocal = environment.isLocal;
    return this.http
      .get<GoogleConfigurations>(
        `${ApiEndpoints.ConfigurationsApi.GetGoogleAPIConfigurations}${key}/${isLocal}`,
      )
      .pipe(take(1));
  }

  public GetConfigurations(): Observable<Configurations> {
    return this.http
      .get<Configurations>(ApiEndpoints.ConfigurationsApi.GetAllConfigurations)
      .pipe(take(1));
  }

  public getGoogleCustomToken(): Observable<CustomTokenDTO> {
    return this.http
      .get<CustomTokenDTO>(ApiEndpoints.CommonApis.GoogleCustomToken)
      .pipe(take(1));
  }

  public GetAllToolsApi(): Observable<AppTools> {
    return this.http
      .get<AppTools>(ApiEndpoints.Tools.GetAllToolsForDraw)
      .pipe(take(1));
  }
}
